"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ProductFruitsUtil {
}
ProductFruitsUtil.destroy = () => {
    var _a, _b, _c;
    (_c = (_b = (_a = window.productFruits) === null || _a === void 0 ? void 0 : _a.services) === null || _b === void 0 ? void 0 : _b.destroy) === null || _c === void 0 ? void 0 : _c.call(_b);
};
exports.default = ProductFruitsUtil;
